module.exports = __webpack_public_path__ + "img/ipad-mobile_cn.ec06cfe.jpg";